import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import axios from 'axios'

import OrganizationAPI from './api'

export default class Organization extends Model {
  static api = OrganizationAPI.create(Organization)
  static readOnlyFields = ['id']

  constructor({ id = null, name = '', tags = [] } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
      tags,
    })
  }

  static create(opts = {}) {
    return new Organization(opts)
  }

  static fromAPI(json = {}) {
    const data = snakeToCamel(json)
    return new Organization(data)
  }

  copy() {
    return new Organization(this)
  }
}
